import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { Agent } from "tekkr-common/dist/model/agent/agent";

export function useGetAgentQuery(agentId: string) {
    return useQuery({
        queryKey: ["agent", agentId],
        queryFn: async (): Promise<Agent> => {
            const res = await apiClient.getAgent({
                params: {
                    agentId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to fetch agent");
            }
            return res.body.data;
        },
    });
}
